module.exports = __webpack_public_path__ + "img/subscript.80e065ec.svg";